import { getAuth, signOut } from "firebase/auth";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { setStoredDeepLink } from "@canucci/base/auth";

function LogoutPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();
  const { t } = useTranslation("pages");
  const from = location.state?.from;

  useEffect(() => {
    const auth = getAuth();
    signOut(auth)
      .finally(() => {
        queryClient.clear();
        if (from) {
          setStoredDeepLink(from.pathname + from.search);
        } else {
          setStoredDeepLink("/");
        }
        navigate("/login", { replace: true });
      })
      .catch((error) => {
        console.error("Logout failed", error);
      });
  }, [navigate, from, queryClient]);

  return <div>{t("logout.loggingOut")}</div>;
}

export default LogoutPage;
